module.exports = __webpack_public_path__ + "media/bootstrap-icons/reception-1-b2f04bf1.svg";